export default function (settings) {
  return settings.map((setting) => ({
    key: setting.key,
    value: setting.value,
    saved: setting.saved,
  }))
}
